module.exports = __webpack_public_path__ + "images/edf75451b5b4a05088bd2048bb888820.jpg";